import { render } from "./BahrainPage.vue?vue&type=template&id=7c8ec144&scoped=true"
import script from "./BahrainPage.vue?vue&type=script&lang=js"
export * from "./BahrainPage.vue?vue&type=script&lang=js"

import "./BahrainPage.vue?vue&type=style&index=0&id=7c8ec144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8ec144"]])

export default __exports__